import styled from "styled-components";
import {
	TABLET_BP,
	TABLET_M_BP,
	DESKTOP_SM_BP,
	MOBILE_M_BP,
	COLOR_WHITE,
	FONT_WT_MEDIUM,
	COLOR_TEXT_HIGHLIGHT,
	FONT_WT_LIGHT,
	COLOR_TEXT_PRIMARY_B2C,
	COLOR_BORDER_GREY,
	COLOR_SPRINGBOARD_GRADIENT,
	FONT_WT_REGULAR,
	COLOR_HYPERLINK_HOVER,
	COLOR_HYPERLINK,
	DESKTOP_M_BP,
} from "@website-builder/utilities-index";

export const HeaderWrapper = styled.div`
	&:before {
		position: absolute;
		content: "";
		top: 100%;
		left: 0;
		right: 0;
		height: 3px;
		z-index: 5;
		background-image: ${COLOR_SPRINGBOARD_GRADIENT};
	}
	position: relative;
	height: 80px;
	background: ${COLOR_WHITE};
	padding: 0 20px 0 50px;
	display: flex;
	align-items: center;
	&.homepage {
		@media only screen and (min-width: ${TABLET_M_BP + 1}px) {
			position: fixed;
			top: 0;
			z-index: 99999;
			width: 100%;
		}
	}
	.explore-programs {
		margin-right: 25px;
		font-size: 16px;
		font-weight: ${FONT_WT_LIGHT};
		line-height: 27px;
		text-align: left;
		color: ${COLOR_TEXT_PRIMARY_B2C};

		.primary-button {
			transition: all 0.2s ease-in-out;
			overflow: hidden;
			width: 0;
			padding: 0;
			border: 0;
		}

		@media screen and (min-width: 1250px) {
			&.active {
				.primary-button {
					width: 206px;
					border: 2px;
					margin-left: 8px;
				}
			}
		}
	}
	.logoWrapper {
	}
	.logo {
		height: 40px;
	}
	.hamburgerIcon {
		display: none;
	}
	.linksWrapper {
		margin-left: auto;
		display: flex;
		align-items: center;
	}
	.hamburgerMenu {
		display: flex;
		align-items: center;
		.closeButtonWrapper {
			display: none;
		}
	}
	.navLinksWrapper {
		display: flex;
	}
	.navLink {
		color: ${COLOR_TEXT_PRIMARY_B2C};
		margin-right: 40px;
		font-size: 18px;
		cursor: pointer;
		font-weight: ${FONT_WT_LIGHT};
		& > span,
		& > a {
			line-height: 80px;
			color: ${COLOR_TEXT_PRIMARY_B2C};
			text-decoration: none;
		}
		&:hover.dropdownLink {
			font-weight: ${FONT_WT_MEDIUM};
		}
		&.dropdownLink {
			position: relative;
			.rightIcon {
				display: none;
				padding-left: 20px;
			}
			@media only screen and (max-width: ${DESKTOP_SM_BP - 1}px) {
				.rightIcon {
					display: initial;
				}
			}
			.dropdownMenu {
				&:before {
					content: "";
					position: absolute;
					left: 50%;
					top: -10px;
					width: 0;
					height: 0;
					transform: translateX(-50%);
					border-left: 10px solid transparent;
					border-right: 10px solid transparent;
					border-bottom: 10px solid ${COLOR_WHITE};
				}
				&.courses {
					left: 100px;
					&:before {
						left: calc(50% - 70px);
					}
				}
				display: none;
				z-index: 10;
				position: absolute;
				max-width: 700px;
				padding: 20px 30px;
				background: ${COLOR_WHITE};
				box-shadow: 0 -7px 25px 0 rgba(0, 0, 0, 0.1);
				border-radius: 3px;
				animation-timing-function: ease-in-out;
				transform: translateX(-50%);
				top: 70px;
				left: 50%;
				max-width: 800px;
				white-space: nowrap;
				&.grid {
					.courseLinksContainer {
						display: inline-block;
						width: 380px;
						vertical-align: top;
					}
					.exploreMore {
						hr {
							margin: 8px 15px 10px;
							border: 0;
							border-top: 1px solid #eee;
						}
						@media only screen and (max-width: ${TABLET_BP}px) {
							padding-bottom: 20px;
							display: grid;
						}
						text-align: center;
						grid-column: 1/3;
						font-size: 16px;
						line-height: 27px;
						color: #48485e;
						font-weight: ${FONT_WT_REGULAR};
						span {
							margin-bottom: 0;
							font-size: 16px;
							margin-right: 8px;
						}
						a {
							color: ${COLOR_HYPERLINK};
							&:hover {
								color: ${COLOR_HYPERLINK_HOVER};
								text-decoration: none;
							}
						}
						.exploreCareer {
							text-decoration: underline;
							color: ${COLOR_HYPERLINK};
							:hover {
								text-decoration: none;
							}
						}
					}
				}
				.subMenuHeader {
					display: none;
				}
				.category {
					margin-bottom: 30px;
					.categoryName {
						margin-bottom: 20px;
						margin-top: 10px;
						line-height: 1.5;
						font-size: 14px;
						font-weight: ${FONT_WT_MEDIUM};
						color: ${COLOR_TEXT_HIGHLIGHT};
					}
					.courseLink {
						font-size: 18px;
						font-weight: ${FONT_WT_LIGHT};
						margin-right: 5px;
						margin-bottom: 12px;
						min-height: 31px;
						display: flex;
						text-decoration: none;
						color: ${COLOR_TEXT_PRIMARY_B2C};
						align-items: flex-end;
					}
				}
				&.students {
					a {
						white-space: nowrap;
						color: ${COLOR_TEXT_PRIMARY_B2C};
						text-decoration: none;
						display: block;
						font-weight: ${FONT_WT_LIGHT};
						line-height: 27px;
						text-align: left;
						margin-bottom: 12px;
						&:last-child {
							margin-bottom: 0px;
						}
					}
				}
				&.forCompanies {
					a {
						white-space: nowrap;
						color: ${COLOR_TEXT_PRIMARY_B2C};
						text-decoration: none;
						display: block;
						font-weight: ${FONT_WT_LIGHT};
						line-height: 27px;
						text-align: left;
						margin-bottom: 12px;
						&:last-child {
							margin-bottom: 0px;
						}
					}
				}
				&.howItWorks {
					a {
						white-space: nowrap;
						color: ${COLOR_TEXT_PRIMARY_B2C};
						text-decoration: none;
						display: block;
						font-weight: ${FONT_WT_LIGHT};
						line-height: 27px;
						text-align: left;
						margin-bottom: 12px;
						&:last-child {
							margin-bottom: 0px;
						}
					}
				}
				&.mentors {
					a {
						white-space: nowrap;
						color: ${COLOR_TEXT_PRIMARY_B2C};
						text-decoration: none;
						display: block;
						font-weight: ${FONT_WT_LIGHT};
						line-height: 27px;
						text-align: left;
						margin-bottom: 12px;
						&:last-child {
							margin-bottom: 0px;
						}
					}
				}
			}

			&:hover .dropdownMenu,
			.dropdownMenu:hover {
				display: block;
			}
			&:hover .dropdownMenu.grid,
			.dropdownMenu.grid:hover {
				display: block;
			}
		}
	}
	.navLink:last-child {
		margin-right: 0;
	}
	.loginButtonWrapper {
		margin-left: auto;
	}
	.authWrapper {
		margin-left: 50px;
		.cta {
			padding: 0 10px;
			margin-left: 8px;
		}
	}

	@media only screen and (max-width: 1130px) {
		height: 50px;
		.logo {
			height: 25px;
		}
		.linksWrapper {
			flex-direction: row-reverse;
		}
		.courseLinksContainer {
			display: block !important;
			width: 100%;
			max-width: unset;
		}
		.hamburgerMenu {
			display: ${(props) => (props.showHamburgerMenu ? "block" : "none")};
			position: fixed;
			overflow: scroll;
			background: ${COLOR_WHITE};
			left: 60px;
			height: fit-content;
			box-shadow: 0 2px 40px 0 ${COLOR_TEXT_PRIMARY_B2C};
			right: 0;
			bottom: 0;
			top: 0;
			z-index: 10000;
			padding: 20px;
			.closeButtonWrapper {
				display: block;
				text-align: right;
			}
			.navLinksWrapper {
				flex-wrap: wrap;
				.navLink {
					width: 100%;
					margin-right: 0;
					text-decoration: none;
					& > span,
					& > a {
						line-height: 1;
						padding: 10px 0;
						display: block;
						border-bottom: 1px solid ${COLOR_BORDER_GREY};
					}
					.dropdownMenu {
						&:before {
							border: none;
						}
						.subMenuHeader {
							display: flex;
							padding: 14px 0;
							margin-bottom: 10px;
							border-bottom: 1px solid ${COLOR_BORDER_GREY};
							img.backIcon {
								height: 12px;
								margin-right: 10px;
								transform: rotate(90deg);
							}
						}
						&.courses {
							display: ${(props) =>
								props.hamburgerSubmenu === "courses" ? "block" : "none"};
							position: absolute;
							bottom: 0;
							top: 0;
							left: 0;
							width: 100vw;
						}
						&.students {
							display: ${(props) =>
								props.hamburgerSubmenu === "students" ? "block" : "none"};
							position: absolute;
							bottom: 0;
							top: 0;
							left: 0;
							width: 100vw;
							a.link {
								text-decoration: none;
								color: black;
							}
						}
						&.forCompanies {
							display: ${(props) =>
								props.hamburgerSubmenu === "forCompanies" ? "block" : "none"};
							position: absolute;
							bottom: 0;
							top: 0;
							left: 0;
							width: 100vw;
							a.link {
								text-decoration: none;
								color: black;
							}
						}
						&.howItWorks {
							display: ${(props) =>
								props.hamburgerSubmenu === "howItWorks" ? "block" : "none"};
							position: absolute;
							bottom: 0;
							top: 0;
							left: 0;
							width: 100vw;
							a.link {
								text-decoration: none;
								color: black;
							}
						}
						&.mentors {
							display: ${(props) =>
								props.hamburgerSubmenu === "mentors" ? "block" : "none"};
							position: absolute;
							bottom: 0;
							top: 0;
							left: 0;
							width: 100vw;
							a.link {
								text-decoration: none;
								color: black;
							}
						}
					}
					&.dropdownLink:hover .dropdownMenu,
					.dropdownMenu,
					.dropdownMenu:hover {
						top: 0;
						left: 0;
						transform: unset;
						box-shadow: none;
					}
					&.dropdownLink {
						position: unset;
					}
				}
			}
			.authWrapper {
				margin: 30px 0 0 0;
				text-align: center;
			}
		}
		.hamburgerIcon {
			display: flex;
			margin-left: auto;
			cursor: pointer;
			img {
				height: 27px;
			}
		}
	}
`;

export const UserAvatarWrapper = styled.div`
	display: flex;
	position: relative;
	align-items: center;
	cursor: pointer;
	.imageWrapper {
		border-radius: 25px;
		overflow: hidden;
		margin-right: 10px;
		height: 50px;
		width: 50px;
	}
	img {
		height: 50px;
	}
	.backdrop {
		display: ${(props) => (props.showUserMenu ? "block" : "none")};
		position: fixed;
		top: 0;
		bottom: 0;
		background: transparent;
		left: 0;
		right: 0;
		z-index: 4;
	}
	.userMenu {
		&:before {
			content: "";
			position: absolute;
			left: 50%;
			top: -10px;
			width: 0;
			height: 0;
			transform: translateX(-50%);
			border-left: 10px solid transparent;
			border-right: 10px solid transparent;
			border-bottom: 10px solid ${COLOR_TEXT_PRIMARY_B2C};
		}
		display: ${(props) => (props.showUserMenu ? "block" : "none")};
		position: absolute;
		background-color: ${COLOR_TEXT_PRIMARY_B2C};
		padding: 20px 12px;
		top: 65px;
		left: -65px;
		min-width: 180px;
		z-index: 5;
		a,
		span {
			color: ${COLOR_WHITE};
			cursor: pointer;
			text-decoration: none;
			display: block;
			line-height: 27px;
		}
	}
	@media only screen and (max-width: ${DESKTOP_SM_BP - 1}px) {
		margin-right: 30px;
		.userName {
			display: none;
		}
		.imageWrapper {
			border-radius: 15px;
			overflow: hidden;
			height: 30px;
			width: 30px;
		}
		img {
			height: 30px;
		}
		.userMenu {
			&:before {
				left: 115px;
			}
			left: -100px;
			top: 50px;
		}
	}
`;

export const Badge = styled.div`
	background-color: ${(props) => props.backgroundColor};
	border-radius: 12px;
	line-height: 21px;
	text-align: center;
	font-size: 12px;
	font-weight: ${FONT_WT_REGULAR};
	color: ${COLOR_WHITE};
	margin-left: 5px;
	padding: 0 8px;
	margin-bottom: 10px;
	@media only screen and (max-width: ${DESKTOP_SM_BP - 1}px) {
		display: none;
	}
`;

export const FooterWrapper = styled.div`
	padding: 50px 100px;
	background-color: #efeff6;
	border: 1px solid ${COLOR_BORDER_GREY};
	.linkSectionsWrapper {
		display: flex;
		justify-content: space-between;
		.linkSection {
			width: 25%;
			.name {
				margin: 0px 0 19px 0;
				font-weight: ${FONT_WT_MEDIUM};
				color: ${COLOR_TEXT_PRIMARY_B2C};
				text-transform: uppercase;
				font-size: 16px;
				line-height: 27px;
				text-align: left;
				&:not(:first-child) {
					margin-top: 20px;
				}
			}
			.link {
				padding-bottom: 15px;
				display: block;
				text-decoration: none;
				font-size: 16px;
				font-weight: ${FONT_WT_LIGHT};
				line-height: 27px;
				text-align: left;
				color: ${COLOR_TEXT_PRIMARY_B2C};
				&:hover {
					color: ${COLOR_HYPERLINK_HOVER};
				}
			}
			.countrySelect {
				width: 160px;
			}
		}
	}
	.footerLinks {
		display: flex;
		font-weight: ${FONT_WT_LIGHT};
		.logoSection {
			display: flex;
			align-items: center;
			.logo {
				background-position: 0 -78px;
				background-repeat: no-repeat;
				width: 200px;
				height: 46px;
			}
			.copyright {
				min-width: 107px;
				margin-left: 80px;
				margin-right: 40px;
				color: ${COLOR_TEXT_PRIMARY_B2C};
			}
		}
		.legalItems {
			display: flex;
			align-items: center;
			.link {
				margin-right: 10px;
				color: ${COLOR_TEXT_PRIMARY_B2C};
				text-decoration: none;
				&:hover {
					color: ${COLOR_HYPERLINK_HOVER};
				}
			}
		}
	}
	@media only screen and (max-width: ${DESKTOP_M_BP}px) {
		padding: 50px 60px;
		.footerLinks {
			.logoSection {
				.copyright {
					min-width: 60px;
					margin: 0 25px;
				}
			}
		}
	}
	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		padding: 50px 10px;
		.footerLinks {
			margin-top: 20px;
			.copyright {
				margin: 0 20px;
			}
		}
	}
	@media only screen and (max-width: ${TABLET_M_BP}px) {
		.footerLinks {
			.logoSection {
				flex-flow: column;
				align-items: flex-start;
				.logo {
					margin-bottom: 10px;
				}
				.copyright {
					margin: 0;
				}
			}
			.legalItems {
				margin-left: 40px;
				margin-bottom: 15px;
			}
		}
	}
	@media only screen and (max-width: ${TABLET_BP - 1}px) {
		padding: 46px 0 30px 25px;
		.linkSectionsWrapper {
			display: block;
			.linkSection {
				width: 100%;
				margin-top: 30px;
			}
		}
		.footerLinks {
			flex-flow: column;
			.logoSection {
				.logo {
					margin-bottom: 20px;
				}
				.copyright {
					min-width: 107px;
					margin-left: 0;
				}
			}
			.legalItems {
				margin-left: 0;
				flex-wrap: wrap;
				.link {
					width: 100%;
					margin-top: 20px;
				}
			}
		}
	}
	@media only screen and (max-width: ${MOBILE_M_BP}px) {
		.footerLinks {
			.copyright,
			.link {
				width: 100%;
				margin-bottom: 20px;
				margin-top: 0px;
			}
		}
	}
`;

export const SocialIcon = styled.div`
	display: inline-block;
	margin-right: 10px;
	width: 25px;
	height: 25px;
	background-size: cover;
`;
